export default "__VITE_ASSET__DcVml5tt__"